const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const EXPERIENCE = {
    // ----- LICENSE -----
    LICENSE_CREATE: `${API_BASE_URL}/experience/license-create/`,
    LICENSE_LIST: `${API_BASE_URL}/experience/profile/licenses/`,
    LICENSE_UPDATE: (id) => `${API_BASE_URL}/experience/licenses/${id}/`,
    LICENSE_DELETE: (id) => `${API_BASE_URL}/experience/licenses/${id}/`,

    // ----- CERTIFICATE -----
    CERTIFICATE_CREATE: `${API_BASE_URL}/experience/certificate-create/`,
    CERTIFICATE_LIST: `${API_BASE_URL}/experience/profile/certificates/`,
    CERTIFICATE_UPDATE: (id) => `${API_BASE_URL}/experience/certificates/${id}/`,
    CERTIFICATE_DELETE: (id) => `${API_BASE_URL}/experience/certificates/${id}/`,
};

export default EXPERIENCE;